export const prefix = 'COOKIE_CONSENT';
export const domain = 'CookieConsent';
